










import { Vue, Component } from 'vue-property-decorator';
import AlertasBase from '@/pantallas/ConfigurarBase/AlertasBase.vue';

@Component({
  components: { AlertasBase },
})
export default class AlertaBasePantalla extends Vue {}
